import { useAuthStore } from '../model/auth.store';

/**
 * 현재 세션이 인증된 사용자 상태인가.
 * 토큰 보유만 검사 — user 프로필 fetch 는 페이지가 자기 책임으로 (`useUserProfileQuery`).
 * 토큰 유효성 (BE reject) 은 axios 인터셉터의 401 처리가 횡단 담당.
 *
 * React 트리 밖 (axios interceptor / navigation loader) 에서도 호출 가능 —
 * zustand `getState()` 는 imperative API.
 */
export function isAuthenticated(): boolean {
  return !!useAuthStore.getState().accessToken;
}
